import React from 'react'
import { Divider as MDivider, DividerProps } from '@mui/material'

interface Props extends DividerProps {
  light?: boolean
}

export const Divider = React.forwardRef<HTMLHRElement, Props>(({ light, ...rest }, ref) => (
  <MDivider
    ref={ref}
    sx={(theme) => ({
      height: 2,
      backgroundColor: light ? theme.custom.colors.common.grey : theme.custom.colors.common.black,
    })}
    {...rest}
  />
))
